// Exports
export default {
	"stars": "stars_0poyn",
	"starButton": "starButton_9jyxT",
	"starIcon": "starIcon_jtTwA",
	"starButtonActive": "starButtonActive_AioI7"
};
